import React, { useCallback, useEffect, useState } from 'react';

interface ScriptData {
  src: string;
  async: boolean;
  defer: boolean;
}

const ThirdPartyScriptLoader = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [startedLoading, setStartedLoading] = useState(false);

  const loadScript = useCallback(async ({ src, async, defer }: ScriptData) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.type = 'text/javascript';

    document.head.appendChild(script);
  }, []);

  const loadReddit = useCallback(async () => {
    const script = document.createElement('script');
    script.innerHTML =
      "!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement(\"script\");t.src=\"https://www.redditstatic.com/ads/pixel.js\",t.async=!0;var s=d.getElementsByTagName(\"script\")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_ekhq3a2jqrod');rdt('track', 'PageVisit');";
    document.head.appendChild(script);
  }, []);

  const loadBing = useCallback(async () => {
    const script = document.createElement('script');
    script.innerHTML =
      '(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"97035896", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq"); function uet_report_conversion_purchase(analyticsProperties) {window.uetq = window.uetq || [];window.uetq.push("event", "PRODUCT_PURCHASE", {analyticsProperties});}; function uet_report_conversion_signup(analyticsProperties) {window.uetq = window.uetq || [];window.uetq.push("event", "signup", {});}';
    document.head.appendChild(script);
  }, []);

  const loadMntn = useCallback(async () => {
    const script = document.createElement('script');
    script.innerHTML =
      '(function(){"use strict";var e=null,b="4.0.0",n="37473",additional="term=value",t,r,i;try{t=top.document.referer!==""?encodeURIComponent(top.document.referrer.substring(0,2048)):""}catch(o){t=document.referrer!==null?document.referrer.toString().substring(0,2048):""}try{r=window&&window.top&&document.location&&window.top.location===document.location?document.location:window&&window.top&&window.top.location&&""!==window.top.location?window.top.location:document.location}catch(u){r=document.location}try{i=parent.location.href!==""?encodeURIComponent(parent.location.href.toString().substring(0,2048)):""}catch(a){try{i=r!==null?encodeURIComponent(r.toString().substring(0,2048)):""}catch(f){i=""}}var l,c=document.createElement("script"),h=null,p=document.getElementsByTagName("script"),d=Number(p.length)-1,v=document.getElementsByTagName("script")[d];if(typeof l==="undefined"){l=Math.floor(Math.random()*1e17)}h="dx.mountain.com/spx?"+"dxver="+b+"&shaid="+n+"&tdr="+t+"&plh="+i+"&cb="+l+additional;c.type="text/javascript";c.src=("https:"===document.location.protocol?"https://":"http://")+h;v.parentNode.insertBefore(c,v)})();function mntn_conversion_purchase(analyticsProperties) {var x=null,p,q,m,o="37473",l=(analyticsProperties.checkout_id),i=(analyticsProperties.revenue),c=(analyticsProperties.currency),k=(analyticsProperties.email),g="",j="",u=(analyticsProperties.user_id),shadditional="";try{p=top.document.referer!==""?encodeURIComponent(top.document.referrer.substring(0,512)):""}catch(n){p=document.referrer!==null?document.referrer.toString().substring(0,512):""}try{q=window&&window.top&&document.location&&window.top.location===document.location?document.location:window&&window.top&&window.top.location&&""!==window.top.location?window.top.location:document.location}catch(b){q=document.location}try{m=parent.location.href!==""?encodeURIComponent(parent.location.href.toString().substring(0,512)):""}catch(z){try{m=q!==null?encodeURIComponent(q.toString().substring(0,512)):""}catch(h){m=""}}var A,y=document.createElement("script"),w=null,v=document.getElementsByTagName("script"),t=Number(v.length)-1,r=document.getElementsByTagName("script")[t];if(typeof A==="undefined"){A=Math.floor(Math.random()*100000000000000000)}w="dx.mountain.com/spx?conv=1&shaid="+o+"&tdr="+p+"&plh="+m+"&cb="+A+"&shoid="+l+"&shoamt="+i+"&shocur="+c+"&shopid="+k+"&shoq="+g+"&shoup="+j+"&shpil="+u+shadditional;y.type="text/javascript";y.src=("https:"===document.location.protocol?"https://":"http://")+w;r.parentNode.insertBefore(y,r)}';
    document.head.appendChild(script);
  }, []);

  const scriptsToLoad: ScriptData[] = [];

  if (
    process.env.KLAVIYO_COMPANY_IDENTIFIER &&
    process.env.DISABLE_KLAVIYO !== 'true'
  ) {
    scriptsToLoad.push({
      src: `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${process.env.KLAVIYO_COMPANY_IDENTIFIER}`,
      async: true,
      defer: false,
    });
  }

  useEffect(() => {
    if (!startedLoading) {
      setStartedLoading(true);
      scriptsToLoad.forEach((scriptData) => loadScript(scriptData));
      if (process.env.NODE_ENV == 'production') {
        loadReddit();
        loadBing();
        loadMntn();
      }
    }
  }, [loadScript, startedLoading]);

  return <>{children}</>;
};

export default ThirdPartyScriptLoader;
